import { UserEditHandler } from "./user-edit-handler";
import { registerUserEditMasterDataListener } from "./user-edit-listener";

interface MasterDataEditControllerLike {
    modal: HTMLElement | null;
    form: HTMLFormElement | null;
    resource: string;
    lookupUserAddressByZipCode(zip: string): Promise<void>;
    openUserPrefectureModal(): void;
    renderUserPrefectureDisplay(value: string): void;
    clearUserPrefecturePendingValue(): void;
    applyUserPrefecturePendingValue(): void;
    closeUserPrefectureModal(): void;
    renderUserPrefectureModalList(filterText?: string): void;
}

export class UserEditSetup {
    public static init(): void {
        const handler = new UserEditHandler();
        handler.init();
    }
}

export function registerMasterDataEditUsersListener(controller: MasterDataEditControllerLike): void {
    registerUserEditMasterDataListener(controller);
}
